import { Trans, useTranslation } from "react-i18next";
import SetMessage from "@assets/svg/setMessage.svg?react";
import Eye from "@assets/svg/Eye.svg?react";
import {
  SelectInspectionWrapper,
  Title,
  SettingsBox,
  SettingsHeader,
  SettingsTitle,
  SettingsListWrapper,
  SettingsList,
  SettingsListItem,
  PreviewButton,
  EmailStatusContainer,
  StatusIcon,
  StatusMessage,
} from "./styles";
import Sucessconnections from "@assets/svg/Sucessconnections.svg?react";
import Failedconnections from "@assets/svg/Failedconnections.svg?react";
interface SelectInspectionProps {
  sendEmailTemplate?: () => void;
  sendEmailStatus?: number;
}

const SelectInspection = ({sendEmailTemplate,sendEmailStatus}:SelectInspectionProps) => {
  const { t } = useTranslation();

  return (
    <SelectInspectionWrapper>
      <Title>{t("MESSAGING.SEND_WELCOME_PREVIEW")}</Title>

      <SettingsBox>
        <SettingsHeader>
          <SettingsTitle>
            <SetMessage style={{ width: "10px", height: "10px" }} />
            <span style={{ marginInline: "8px" }}>
              {t("MESSAGING.SENDING_SETTINGS")}
            </span>
          </SettingsTitle>
        </SettingsHeader>

        <SettingsListWrapper>
          <SettingsList>
            <SettingsListItem>
              <Trans
                i18nKey="MESSAGING.EMAIL_WILL_BE_SENT_FROM"
                components={{ bold: <strong style={{ fontWeight: 700 }} /> }}
                values={{ email: "connect@msool.io" }}
              />
            </SettingsListItem>
            <SettingsListItem>
              <Trans
                i18nKey="MESSAGING.EMAIL_SUBJECT_EXAMPLE"
                components={{ bold: <strong style={{ fontWeight: 700 }} /> }}
              />
            </SettingsListItem>
            <SettingsListItem>
              <Trans
                i18nKey="MESSAGING.EMAIL_MESSAGE_EXAMPLE"
                components={{ bold: <strong style={{ fontWeight: 700 }} /> }}
              />
            </SettingsListItem>
          </SettingsList>
        </SettingsListWrapper>
      </SettingsBox>

      <PreviewButton onClick={sendEmailTemplate}>
        <Eye style={{ width: "24px", height: "24px" }} />
        {t("MESSAGING.PREVIEW_MESSAGE_INSPECTION")}
      </PreviewButton>
      <EmailStatusContainer visible={Boolean(sendEmailStatus && sendEmailStatus > 0)}>
        <StatusIcon>
          {sendEmailStatus === 1 ? 
            <Sucessconnections style={{width: "40px", height: "40px"}}/> :
            <Failedconnections style={{width: "40px", height: "40px"}}/>
          }
        </StatusIcon>
        <StatusMessage>
          {sendEmailStatus === 1 ?
            t("MESSAGING.EMAIL_SENT_SUCCESS") :
            t("MESSAGING.EMAIL_SENT_FAIL")
          }
        </StatusMessage>
      </EmailStatusContainer>
    </SelectInspectionWrapper>
  );
};

export { SelectInspection };
